import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { EmpathySection } from './components/EmpathySection';
import { VisionSection } from './components/VisionSection';
import { AuthorSection } from './components/AuthorSection';
import { BenefitsGrid } from './components/BenefitsGrid';
import { FeaturesSection } from './components/FeaturesSection';
import { Testimonials } from './components/Testimonials';
import { OfferSection } from './components/OfferSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
const META_PIXEL_ID = '1744921309871699';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Note: the pixel base code + PageView already fired synchronously
    // in index.tsx (before React renders), guaranteeing window.fbq is
    // available for any subsequent AddToCart / InitiateCheckout calls
    // and that Meta Pixel Helper detects the install.
    //
    // Here we only fire ViewContent slightly after mount so it carries
    // accurate product data and isn't deduplicated with PageView.
    const viewContentTimer = window.setTimeout(() => {
      window.fbq?.('track', 'ViewContent', {
        content_name: 'Historias infantiles para dormir en paz',
        content_type: 'product',
        value: 12990,
        currency: 'ARS'
      });
    }, 1200);
    return () => {
      window.clearTimeout(viewContentTimer);
    };
  }, []);
  return <div className="min-h-screen flex flex-col" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>
      <main className="flex-grow" data-id="element-3">
        <Hero data-id="element-4" />
        <EmpathySection data-id="element-5" />
        <VisionSection data-id="element-6" />
        <AuthorSection data-id="element-7" />
        <BenefitsGrid data-id="element-8" />
        <FeaturesSection data-id="element-9" />
        <Testimonials data-id="element-10" />
        <OfferSection data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <RecentPurchaseToast data-id="element-15" />
    </div>;
}